export default [
  {
    content: "전단 날 전면 방호가드, 광전자식 방호장치 등이 부착되어 있는가?",
    isChecked: "",
  },
  {
    content: "작업용 발판의 보도면이 쉽게 미끄러지거나 넘어지지 아니한 상태인가?",
    isChecked: "",
  },
  {
    content: "기기 외함 접지 등 전기 감전 예방조치는 적절한가?",
    isChecked: "",
  },
  {
    content: "전기장치는 직접접촉이나 간접접촉으로 전용 외함 내부에 내장, 방호망 설치 등 방호 조치를 하였는가?",
    isChecked: "",
  },
  {
    content: "배선의 피복 상태는 손상, 파손, 탄화부분이 없으며, 제어반 등의 전선인입구에는 배선피복이 손상되지 않도록 보호조치가 되어 있는가?",
    isChecked: "",
  },
  {
    content: "비상정지장치는 각 제어반 및 그 밖의 비상정지를 필요로 하는 개소에 설하되, 접근이 용이한 곳에 배치되어 있는가?",
    isChecked: "",
  },
  {
    content: "작고 폭이 좁은 소재는 수공구를 사용하는가?",
    isChecked: "",
  },
  {
    content: "전단기의 발 조작용 페달에는 덮개는 부착되어있는가?",
    isChecked: "",
  },
  {
    content: "중량물의 소재 취급 시 운반기계를 사용하는가?",
    isChecked: "",
  },
  {
    content: "2인1조 공동 작업 시 안전한 작업을 위한 신호는 확립되어있는가?",
    isChecked: "",
  },
  {
    content: "작업장 주변은 자재, 이물질 등 정리정돈이 되어있는가?",
    isChecked: "",
  },
  {
    content: "작업자는 안전화, 보호장갑 등을 착용하고 있는가?",
    isChecked: "",
  },
  {
    content: "정비, 수리, 청소 등의 작업 시 전원차단 및 조작금지 표지를 부착하는가?",
    isChecked: "",
  },
];
